/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React from 'react';

import { FormSection } from '@fitinsur/components'

import { BrokerRemunerationFeeClientSection } from '../index';

function RenderSection({
  disableAll,
  formikProps,
  formikRef,
  idProduct,
  idOperation,
  idOperationParent,
  globalQuestionnaire,
  setShowBrokerRemunerationSection,
  brokerRemunerationGroup,
  setBrokerRemunerationGroup,
  questionnaireAnswersToDelete,
  setQuestionnaireAnswersToDelete,
}) {

  return (
    <FormSection
      sectionName="BROKER_REMUNERATION_FEE_CLIENT"
      formikRef={formikRef}
      disableAll={disableAll}
      values={formikProps.values}
      errors={formikProps.errors}
      setFieldValue={formikProps.setFieldValue}
      setFieldError={formikProps.setFieldError}
      questionnaire={globalQuestionnaire}
      idOperation={idOperation}
      idOperationParent={idOperationParent}
      idProduct={idProduct}
      onQuestionChange={(
        question,
        value,
        questionnaireUpdated,
        setQuestionnaireUpdated,
        setFieldValue
      ) =>
        BrokerRemunerationFeeClientSection.events.handleQuestionChange({
          question,
          value,
          questionnaireUpdated,
          setQuestionnaireUpdated,
          setFieldValue,
          globalQuestionnaire,
          setShowBrokerRemunerationSection,
          brokerRemunerationGroup,
          setBrokerRemunerationGroup,
          questionnaireAnswersToDelete,
          setQuestionnaireAnswersToDelete,
        })
      }
    />
  )
}

const components = {
  RenderSection
}

export { components }